// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.juvelook-product h6 {
    /* padding-top: 0!important; */
    color: #1B5EA5 !important;
    font-family: "ParagraphFonts", serif !important;
    font-weight: bold;
    margin-bottom: 8px;

}

@media(min-width: 992px) {
  
    .subtitle-p {
        margin-bottom: 48px
    }

    .juvelook-product h6 {
        font-size: 0.875rem;
    }

    .juvelook-product li , .juvelook-product p {
        font-size: 13px !important;
    }

    .key-benifits-h6 {
        padding-top: 132px;


    }
}


@media(min-width:768px) and (max-width:991px) {
   html[dir='ltr'] .juvelook-product .container{
        padding-left: 96px !important;
        /* padding-right: 64px !important; */
    }
    /* html[dir='rtl'] .juvelook-product */



    html[dir='rtl'] .juvelook-product .container{
        padding-right: 96px!important;
    }
    .juvelook-product h5,
    .juvelook-product h6 {
        font-size: 11px !important;
        font-weight: 600 !important;
    }

    .juvelook-product p,
    .juvelook-product li {
        font-size: 9px !important;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/brands/components/JuvelookProductComponent.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,+CAA+C;IAC/C,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;;IAEI;QACI;IACJ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;;;IAGtB;AACJ;;;AAGA;GACG;QACK,6BAA6B;QAC7B,oCAAoC;IACxC;IACA,sCAAsC;;;;IAItC;QACI,6BAA6B;IACjC;IACA;;QAEI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;;QAEI,yBAAyB;IAC7B;;AAEJ","sourcesContent":[".juvelook-product h6 {\n    /* padding-top: 0!important; */\n    color: #1B5EA5 !important;\n    font-family: \"ParagraphFonts\", serif !important;\n    font-weight: bold;\n    margin-bottom: 8px;\n\n}\n\n@media(min-width: 992px) {\n  \n    .subtitle-p {\n        margin-bottom: 48px\n    }\n\n    .juvelook-product h6 {\n        font-size: 0.875rem;\n    }\n\n    .juvelook-product li , .juvelook-product p {\n        font-size: 13px !important;\n    }\n\n    .key-benifits-h6 {\n        padding-top: 132px;\n\n\n    }\n}\n\n\n@media(min-width:768px) and (max-width:991px) {\n   html[dir='ltr'] .juvelook-product .container{\n        padding-left: 96px !important;\n        /* padding-right: 64px !important; */\n    }\n    /* html[dir='rtl'] .juvelook-product */\n\n\n\n    html[dir='rtl'] .juvelook-product .container{\n        padding-right: 96px!important;\n    }\n    .juvelook-product h5,\n    .juvelook-product h6 {\n        font-size: 11px !important;\n        font-weight: 600 !important;\n    }\n\n    .juvelook-product p,\n    .juvelook-product li {\n        font-size: 9px !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
